const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchSubscriptionTemplates = async (filters = {}) => {
  try {
    const token = localStorage.getItem('authToken');
    const query = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/templates/getall_subscription_template?${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch subscription templates');
    }

    const data = await response.json();
    return data.msg || [];
  } catch (error) {
    console.error('Error fetching subscription templates:', error);
    return [];
  }
};
  

  export const updateSubscriptionTemplate = async (templateId, updatedData) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${BASE_URL}/eci/apis/v4/templates/${templateId}/edit_subscription_template`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(updatedData),
        }
      );
  
      if (!response.ok) {
        throw new Error('Failed to update subscription template');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating subscription template:', error);
      throw error;
    }
  };
  

  export const createSubscriptionTemplate = async (templateData) => {
    console.log("call came here with payload",templateData)
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${BASE_URL}/eci/apis/v4/templates/create_subscription_template`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(templateData),
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to create subscription template");
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error creating subscription template:", error);
      throw error;
    }
  };